import React, { FC, useState, useEffect, FormEvent } from "react";
import "./loginModalv2.scss";
// react router dom
import { useNavigate } from "react-router-dom";
// localizations
import { withTranslation, useTranslation } from "react-i18next";
// Api Services
import { authService } from "../../../services";
// import Redux
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../store";
import FreezScreen from "../../../components/FreezScreen";
// material ui
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DoneIcon from "@mui/icons-material/Done";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
// svg icons
import IMAGES from "../../../assets/images"
// internal components
import FbLogin from "../../../components/FbLogin/FbLogin";
import LoginGoogle from "../../../components/LoginGoogle/LoginGoogle";
import AppleLogin from "../../../components/AppleLogin/AppleLogin";
import Page from "../../../components/Page"
import InputMaskField from "../../../components/react-input-mask/inputfield"
import TextField from "@mui/material/TextField";
// phone validation utilities
import { Countries, validatePhoneNumber, getMaskPattern, getMaxDigits } from "../../../utils/phoneValidation";


interface LoginModalProps {
  closeBtn: Boolean;
}

interface LoginValuesInterface {
  phoneCode: string;
  phoneNumber: string;
  firstName: any
}


const LoginModal: FC<LoginModalProps> = ({ closeBtn }) => {
  const { t } = useTranslation();
  const state = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const { langValueState, freezScreenState, alertMessageState, formDataState } = bindActionCreators(actionCreators, dispatch);
  const [fullWidth] = React.useState(true);
  // const [purpose, setPurpose] = useState("signIn");
  const [showNameField, setShowNameField] = useState(true)
  const navigate = useNavigate();
  const [loading] = useState<boolean>(false);
  const [loginValues, setLoginValues] = useState<LoginValuesInterface>({
    phoneCode: (state?.formData as any)?.phoneCode || "965",
    phoneNumber: (state?.formData as any)?.phoneNumber || "",
    firstName: (state?.formData as any)?.firstName || ""
  });
  
  // ✅ Country and phone validation state
  const [selectedCountry, setSelectedCountry] = useState(() => {
    // Initialize with country from state or default to Kuwait
    const phoneCode = (state?.formData as any)?.phoneCode || "965";
    const savedCountry = Countries.find(c => c.dial_code === `+${phoneCode}`) || Countries[0];
    return savedCountry;
  });
  const [phoneError, setPhoneError] = useState("");
  const [countryMenuAnchor, setCountryMenuAnchor] = useState<null | HTMLElement>(null);

  // Sync selectedCountry when formData changes
  useEffect(() => {
    if ((state?.formData as any)?.phoneCode) {
      const phoneCode = (state?.formData as any)?.phoneCode;
      const country = Countries.find(c => c.dial_code === `+${phoneCode}`) || Countries[0];
      if (country.code !== selectedCountry.code) {
        setSelectedCountry(country);
      }
    }
  }, [(state?.formData as any)?.phoneCode]);

  const date = new Date();
let year = date.getFullYear();
useEffect(() => {
 if(state?.shopUrl){
  let url = state.shopUrl;

// Create a URL object
let parsedUrl = new URL(url);

// Extract the protocol and hostname
let baseUrl = `${parsedUrl.protocol}//${parsedUrl.hostname}`;

console.log(baseUrl);
let redirectUrlStatus = baseUrl === "https://booking.enabill.com" ? true : false;
setShowNameField(true)
 }
  
}, [state?.shopUrl])


  // Handle country change
  const handleCountryChange = (countryCode: string) => {
    const country = Countries.find(c => c.code === countryCode) || Countries[0];
    setSelectedCountry(country);
    
    // Update phone code in loginValues
    const newPhoneCode = country.dial_code.replace('+', '');
    const updatedValues = {
      ...loginValues,
      phoneCode: newPhoneCode,
      phoneNumber: "", // Clear phone number when country changes
    };
    setLoginValues(updatedValues);
    formDataState(updatedValues);
    
    // Clear phone error when country changes
    setPhoneError("");
    setCountryMenuAnchor(null); // Close menu
  };

  const handleCountryMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setCountryMenuAnchor(event.currentTarget);
  };

  const handleCountryMenuClose = () => {
    setCountryMenuAnchor(null);
  };

  // ✅ Enhanced phone number validation
  const updateField = (event: Event | any) => {
    const { name, value } = event.target;

    if (name === "phoneNumber") {
      const maxDigits = getMaxDigits(selectedCountry.code);
      const currentLength = loginValues.phoneNumber?.length || 0;
      
      // ✅ Allow deletion (value length decreasing) or if within max limit
      const isDeleting = value.length < currentLength;
      const isWithinLimit = value.length <= maxDigits;
      
      if (isDeleting || isWithinLimit) {
        const updatedValues = {
          ...loginValues,
          [name]: value,
        };
        setLoginValues(updatedValues);
        formDataState(updatedValues);

        // ✅ Live validation
        if (value.length > 0) {
          const validation = validatePhoneNumber(value, selectedCountry.code);
          setPhoneError(validation.error);
        } else {
          setPhoneError("");
        }
      }
    } else {
      const updatedValues = {
        ...loginValues,
        [name]: value,
      };
      setLoginValues(updatedValues);
      formDataState(updatedValues);
    }
  };

  useEffect(() => {
    freezScreenState(false);
  }, [])

  const handleGoToShop = () => {
    const shop_url: any = localStorage.getItem(`redirect`);
    window.location.replace(shop_url);

  }
  const phoneLogin = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    freezScreenState(true);
    formDataState(loginValues);
    
    const validation = validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code);
    
    if (loginValues.phoneCode && loginValues.phoneNumber !== "" && validation.isValid) {
      const response = await authService.guestOtp(loginValues.phoneCode, loginValues.phoneNumber, loginValues.firstName);
      freezScreenState(false);
      console.log(response);
      if (response.data.data === true) {
        freezScreenState(false);
        alertMessageState({
          type: "success",
          show: true,
          message: response.data.message,
        });
        navigate("/verify");
        setPhoneError("");
      } else {
        freezScreenState(false);
        alertMessageState({
          type: "error",
          show: true,
          message: response.data.message,
        });
      }
    } else {
      freezScreenState(false);
      alertMessageState({
        type: "error",
        show: true,
        message: validation.error || t("Login.plz-fill-required-fields"),
      });
    }
  };

  return (
    <div>
      <Dialog
        fullWidth={fullWidth}
        open={true}
        // fullScreen={fullScreen}
        BackdropProps={{ invisible: true }}
      // onClose={closeBtn ? handleClose : ""}
      >
        {state.freezScreen && <FreezScreen />}

        <DialogContent>

          <Page title="Login">
            <div
              className={`${state.langValue === "ar" ? "directionRtl" : ""}`}
              id="loginModalMain"
            >
              <div className="row pt-2 ">
                <div className="col-md-12 d-flex justify-content-between classforPaddinglogo ">
                  <img src={IMAGES.enabill} alt="enabill-logo" />
                  <div>
                    {state.langValue === "ar" ? (
                      <Button
                        className="px-5 mx-2 arabicBtn"
                        variant="contained"
                        onClick={() => langValueState("en")}
                      >
                        English
                      </Button>
                    ) : (
                      <Button
                        className="px-5  arabicBtn"
                        variant="contained"
                        onClick={() => langValueState("ar")}
                      >
                        العربيه
                      </Button>
                    )}
                  </div>
                </div>
              </div>
              <h1
                className={`familyManrope800 mt-3 ${state.langValue === "ar" ? "d-flex" : ""
                  }`}
              >
                {t("Login.Verify-Your-Mobile-Number")}
              </h1>
              <p
                className={`familyManrope600 mt-1 textf4f4 ${state.langValue === "ar" ? "d-flex" : ""
                  }`}
              >
                {t("Login.You-will-recieve-a-one-time-password-shortly")}
              </p>

              <form onSubmit={phoneLogin}>
                <div
                  className={`classforPaddingTextfield ${state.langValue === "ar" ? "classforArabicPhone" : ""
                    }`}
                >
                  <div className={`row mt-3  ${state.langValue === "ar" ? "classforArabicPhoneField" : ""
                }`}>
                    <div className="col-12">
                      <InputMaskField
                        value={loginValues?.phoneNumber}
                        onChange={updateField}
                        inputProps={{ inputMode: "numeric", autoComplete: "off" }}
                        autoFocus={false}
                        autoComplete="off"
                        label={t("Forms.phone-number")}
                        className="mt-2"
                        variant="outlined"
                        type="tel"
                        mask={getMaskPattern(selectedCountry.code)}
                        id="outlined-basic"
                        name="phoneNumber"
                        error={!!phoneError}
                        helperText={phoneError}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <div 
                                onClick={handleCountryMenuOpen}
                                style={{ 
                                  display: "flex", 
                                  alignItems: "center", 
                                  cursor: "pointer",
                                  paddingRight: "8px",
                                  borderRight: "1px solid rgba(0, 0, 0, 0.23)",
                                  marginRight: "8px",
                                }}
                              >
                                <img
                                  className="inputadornmentImg flagImg"
                                  src={selectedCountry.flag}
                                  alt={selectedCountry.name}
                                  style={{
                                    width: "24px",
                                    height: "18px",
                                    marginRight: "4px",
                                    objectFit: "cover"
                                  }}
                                  onError={(e) => {
                                    e.currentTarget.style.display = 'none';
                                  }}
                                />
                                <span className="textOver mobCode" style={{ fontSize: "16px", fontWeight: 500 }}>
                                  {selectedCountry.dial_code}
                                </span>
                                <KeyboardArrowDownIcon 
                                  style={{ 
                                    fontSize: "20px", 
                                    marginLeft: "4px",
                                    color: "rgba(0, 0, 0, 0.54)"
                                  }} 
                                />
                              </div>
                            </InputAdornment>
                          ),
                        }}
                      />
                      <Menu
                        anchorEl={countryMenuAnchor}
                        open={Boolean(countryMenuAnchor)}
                        onClose={handleCountryMenuClose}
                        disablePortal={false}
                        MenuListProps={{
                          style: { maxHeight: 300 },
                        }}
                        PaperProps={{
                          style: { 
                            maxHeight: 300,
                            zIndex: 10000,
                          },
                        }}
                        style={{ zIndex: 10000 }}
                      >
                        {Countries.map((country) => (
                          <MenuItem 
                            key={country.code} 
                            onClick={() => handleCountryChange(country.code)}
                            selected={selectedCountry.code === country.code}
                          >
                            <div className="d-flex align-items-center">
                              <img
                                src={country.flag}
                                alt={country.name}
                                style={{
                                  width: "24px",
                                  height: "18px",
                                  marginRight: "8px",
                                  objectFit: "cover"
                                }}
                                onError={(e) => {
                                  e.currentTarget.style.display = 'none';
                                }}
                              />
                              <span className="px-2">{country.name}</span>
                              <span className="text-muted">{country.dial_code}</span>
                            </div>
                          </MenuItem>
                        ))}
                      </Menu>
                    </div>
                  </div>
                  {showNameField && <div className={`row mt-3  ${state.langValue === "ar" ? "classforArabicTextField" : ""}`}>
                    <div className="col-12">
                      <TextField
                        className="mt-1"
                        label={showNameField ? t('Forms.fullNameRequired') : t("Forms.fullName")}
                        type="text"
                        name="firstName"
                        required= {showNameField ? true : false}
                        value={loginValues.firstName}
                        onChange={updateField}
                        variant="outlined"/>
                    </div>
                  </div>}
                </div>
                <div className="classforBtnPadding">
                  <div className="row my-3">
                    <div className="col-12">
                      <Button
                        className={`blackBtn fontSize1rem bgenabill py-3 textCapitalized familyManrope800 ${!validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code).isValid ? "disabled-btn" : ""}`}
                        variant="contained"
                        type="submit"
                        disabled={!validatePhoneNumber(loginValues.phoneNumber, selectedCountry.code).isValid}
                      >
                        {loading ? t("Login.redirecting") : t("Login.Verify")}
                      </Button>
                    </div>
                  </div>
                </div>
              </form>
              {/* //<div className="row mt-2 d-flex justify-content-center">
             // <p className="m-0 text-center">{t("Login.OR")}</p>
           // </div>
            //<div className="classforBtnPadding socialLoginIconOnLargeScreen">
            //<div className="row mt-2 mx-0 ">
              //<div className="col-4 p-0">
                //<FbLogin
                  // fbloginHandleclose={handleClose}
                  // fbloading={loading}
                  // setfbLoading={setLoading}
                  // setAlertMessage={setAlertMessage}
                //  />
               // </div>

                //<div className="col-4 p-0">
                  //<LoginGoogle
                  // loginHandleclose={handleClose}
                  // loading={loading}
                  // setLoading={setLoading}
                  // setAlertMessage={setAlertMessage}
                 // />
                //</div>

                //<div className="col-4 p-0">
                  //<AppleLogin
                  // loginHandleclose={handleClose}
                  // loading={loading}
                  // setLoading={setLoading}
                  // setAlertMessage={setAlertMessage}
                  ///>
                //</div>
              //</div>
            //</div> */}

              <div className="row mt-4 pb-2">
                <div
                  className={`col-12 ${state.langValue === "ar" ? "text-right" : ""
                    }`}
                >
                  <p className="familyManrope600 notRegisterMain ">
                    <span>
                      <img className="img-fluid" src={IMAGES.union} alt="" />
                    </span>
                    <span className="notRegister px-2">
                      {" "}
                      {t("Forms.Save-your-cards")}
                    </span>
                  </p>

                  <hr />

                  <p className="familyManrope600 notRegisterMain">
                    <span>
                      <img className="img-fluid" src={IMAGES.newsPaper} alt="" />
                    </span>
                    <span className="notRegister px-2">
                      {" "}
                      {t("Forms.Tap-to-re-order")}
                    </span>
                  </p>
                  <hr />
                  <p className="familyManrope600 notRegisterMain">
                    <span>
                      <img className="img-fluid" src={IMAGES.giftPaper} alt="" />
                    </span>
                    <span className="notRegister px-2">
                      {" "}
                      {t("Forms.Get-discounts-and-cashbacks")}
                    </span>
                  </p>
                  <hr />
                </div>
              </div>
              <div className="row ">
                <div className={`col-12 ${state.langValue === "ar" ? "" : ""}`}>
                  <p
                    className={`familyManrope600 termsAndCondition text-center ${state.langValue === "ar" ? "direction-ltr" : ""
                      }`}
                  >
                    <span className="textf9f9">
                      {" "}
                      <DoneIcon /> {t("Forms.Terms-&-Conditions-apply")}
                    </span>
                  </p>
                  <p onClick={handleGoToShop} className="familyManrope rights-reserved">
                    © {year} {t("Forms.Enabill-All-rights-reserved")}
                  </p>
                </div>
              </div>
            </div>

          </Page>
        </DialogContent>
      </Dialog>
    </div>
  );
};
export default withTranslation()(LoginModal);
